// extracted by mini-css-extract-plugin
module.exports = {"error_page":"errorMessage_error_page__2UuGA","error_title":"errorMessage_error_title__1M2Kg"};